export default "__VITE_ASSET__f720c9c0__"